import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import AssetCategoryForm from "../../../Components/Forms/Pages/AssetManagement/AssetCategory/AssetCategoryForm";
import {
  editAssetCategory,
  getAssetCategories,
} from '../../../Services/AssetManagement/AssetCategoryService';
import SnackbarContext from "../../../Context/SnackbarContext";
import { filterDropdownItem } from "../../../Util/DropdownUtil";

const formRules = {
    'name': {required: true}
}

const EditVendor = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [parents, setParents] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.assetManagement.assetCategory.editAssetCategory.pageTitle);
    });

    useEffect(() => {
        fetchAssetCategories(); 
    },[])

    const fetchAssetCategories = (term = "") => {
        getAssetCategories({term}).then((response) => {
          if (!response || !response.ok) {
            return;
          }

          setParents(filterDropdownItem(response.data.result, props.data[0]?.id));
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editAssetCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <AssetCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                parents={parents}
                errors={errors} data={data} form={form} control={control}
                onParentChangeFilter={fetchAssetCategories}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditVendor;